import BabelPolyfill from "babel-polyfill";

export {
    BabelPolyfill
}

export default {
    "babel-polyfill": BabelPolyfill
}


// WEBPACK FOOTER //
// ./packages/babel-polyfill@6/index.js